module.exports = __webpack_public_path__ + "img/b3.b858f539.png";